function htmlspecialchars(str: string): string {
  if (typeof str !== "string") {
    return str;
  }
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

// Sanitize all relevant fields on initial load
document.addEventListener("DOMContentLoaded", function () {
  // Select all input fields, textarea, and contenteditable elements
  const fields = document.querySelectorAll(
    "input, textarea, [contenteditable='true']"
  );

  // Function to sanitize the input value
  function sanitizeInput(event: Event) {
    const target = event.target as
      | HTMLInputElement
      | HTMLTextAreaElement
      | HTMLElement;
    // For input and textarea elements
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
      target.value = htmlspecialchars(target.value);
    }
    // For contenteditable elements
    else if (target.getAttribute("contenteditable") === "true") {
      target.innerHTML = htmlspecialchars(target.innerHTML);
    }
  }

  // Attach input event listener to all fields for real-time sanitization
  fields.forEach(function (field) {
    field.addEventListener("input", sanitizeInput);
  });
});

// MutationObserver to handle dynamically added input fields
const observer = new MutationObserver(function (mutationsList) {
  mutationsList.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (
        node instanceof HTMLElement &&
        node.matches("input, textarea, [contenteditable='true']")
      ) {
        node.addEventListener("input", sanitizeInput);
      }
    });
  });
});

// Start observing the document body for dynamically added nodes
observer.observe(document.body, { childList: true, subtree: true });
